var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1885 13.4655C11.8787 13.8077 11.4585 14 11.0203 14C10.5821 14 10.1619 13.8077 9.85206 13.4655L0.504457 3.13858C0.346637 2.97019 0.220753 2.76875 0.134153 2.54603C0.0475524 2.32331 0.00196895 2.08377 6.23885e-05 1.84138C-0.00184417 1.59899 0.0399647 1.3586 0.123049 1.13425C0.206133 0.909905 0.328828 0.706082 0.483976 0.53468C0.639124 0.363277 0.823617 0.227728 1.02669 0.13594C1.22976 0.0441504 1.44735 -0.00203705 1.66675 6.86646e-05C1.88616 0.00217533 2.10299 0.0525341 2.30458 0.148208C2.50618 0.243881 2.68852 0.382952 2.84095 0.557307L11.0203 9.5936L19.1997 0.557307C19.5113 0.224775 19.9287 0.0407734 20.362 0.0449333C20.7952 0.0490923 21.2097 0.241079 21.516 0.579544C21.8224 0.91801 21.9962 1.37587 21.9999 1.85452C22.0037 2.33316 21.8372 2.79429 21.5362 3.13858L12.1885 13.4655Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.57298276fd41a21c76b4d96f1e1dc53e.svg";
export { ForwardRef as ReactComponent };